<template>
  <v-footer
    padless
    max-width="1275"
    style="margin: 0px auto"
  >
    <v-card class="py-3 mx-1 mb-3" elevation="5" style="width: 100%;">
      <v-row justify="center" align="center" class="mx-0 mt-2">
        <v-col v-for="n in support1" cols="6" sm="5" align="center">
          <v-img
            :src="getImgUrl(n)"
            :alt="`responsable ${n}`"
            contain
            max-height="100"
            max-width="250"
          ></v-img>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" class="mx-0 mt-2">
        <v-col v-for="n in support2" cols="6" sm="4" lg="4" align="center">
          <v-img
            :src="getImgUrl(n)"
            :alt="`aliado ${n}`"
            contain
            max-height="100"
            max-width="250"
          ></v-img>
        </v-col>
      </v-row>
      <v-card-actions class="white--text accent" style="">
        <v-spacer></v-spacer>
        <v-btn text color="white" href="https://medium.com/@observatorio.onigies">
          Blog
        </v-btn>
        <v-btn text color="white" :href=" `https://onigies.unam.mx${is_dashboard ? '/' : '/dashboard'}`">
          {{ is_dashboard ? 'Visualización Pública' : 'Registro IES'}}
        </v-btn>
        <v-spacer></v-spacer>
        <a href="https://cieg.unam.mx/" class="white--text" target="_blank" v-if="false">
          {{ new Date().getFullYear() }} — <strong>CIEG-UNAM</strong>
        </a>
      </v-card-actions>      
    </v-card>
    <v-card
      v-if="false"
      flat
      tile
      class="primary--text"
      style="border-top: 3px purple solid;"
    >
      <template v-if="false">
        <span class="text-left ml-3 title grey--text text--darken-1">
          Responsables
        </span>
        <v-card-text class=" pt-0 pb-1 text-left">
          El Sistema fue diseñado por la Secretaría de Igualdad del Centro de Investigaciones y Estudios de Género de la UNAM.
          <v-row>
            <v-col cols="12" sm="6" class="pb-0" v-for="member in team">
              <template v-if="member[0].substr(0,3) == 'Yee'">
                <a 
                  href="https://yeeko.org" 
                  style="text-decoration: none; color: #00000099;">
                  <b>{{member[0]}}</b>
                </a>--{{member[1]}}
              </template>
              <template v-else><b >{{member[0]}}</b>--{{member[1]}}</template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
      </template>
    </v-card>
  </v-footer>
</template>
<script>

import { mapState, } from "vuex";
export default {
  data() {
    return {
      support1:['unam-cieg','coord_igualdad'],
      support2:['inmujeres','cndh','conavim','anuies','renies'],
      team:[
        ['Ana Buquet Corleto', 'Coordinadora del Proyecto'],
        ['Rubén Hernández Duarte', 'Líder del Proyecto'],
        ['Edith Ortiz Romero', 'Líder del Proyecto'],
        ['Sandra Barranco García', 'Asesora en Sistemas de Monitoreo y Evaluación'],
        ['María Fernanda López López', 'Asistente de Investigación y Coordinación Técnica'],
        ['Ricardo Sanginés Contreras', 'Líder de plataforma web y visualización de datos'],
        ['Yeeko Inteligencia Colectiva, SAPI de CV', 'Desarrollo de la plataforma']
      ],
    }

  },
  props:{
    is_dashboard:{
      type: Boolean,
      required: false,
      default: false,
    },
  },    
  methods: {
    getImgUrl(n) {
      var images = require.context('@/assets/', false, /\.png$/)
      return images(`./${n}.png`)
    }      
  },
  computed:{
  }
}
</script>
<style lang="scss">

</style>